module.exports = __webpack_public_path__ + "static/media/icon_person.b96f6703.png";